define('modules/form_editor/views/editor_custom_month_item',['require','exports','module','./editor_dropdown_item','i18n','../../editor/models/editorstate','ldsh!../templates/editor_custom_month_item'],function(require, exports, module){
  "use strict";
  var EditorDropDownItem = require("./editor_dropdown_item"),
      i18n = require("i18n");

  /* Sure there is a better way to do this, but it means refactor */
  var EditorState = require("../../editor/models/editorstate");

  module.exports = EditorDropDownItem.extend({
    template: require("ldsh!../templates/editor_custom_month_item"),
    helpers: function(){
      var translationKey = this.model.get("translationKey");
      try {
        var defaultsModel = EditorState.getVariant().getPropertyGroup("page:defaults"),
            lang = defaultsModel.get("language");
        if (translationKey) translationKey += ("_" + lang);
      } catch(e) {}
      return {
        monthName: this.model.get("text") || i18n.t(translationKey)
      };
    },
  });
});

